import type { IMBEStore } from '@/types';
import { Flex, Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface IStoreListItemProps {
  onSelect?: (store: IMBEStore) => void;
  store: IMBEStore;
}

export const StoreListItem = ({ onSelect, store }: IStoreListItemProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="center" justifyContent="space-between" w="full">
      <Flex direction="column" gap={4}>
        <Text>
          {store.name} <br />
          <Text as="span" fontSize="small">
            {store.streetAddress}, {store.city}
          </Text>
        </Text>
        <Text as="span" fontSize="small">
          {t('STORE.PHONE_NUMBER')} {store.phoneNumber} <br />
          {t('STORE.MAIL')} {store.email}
        </Text>
      </Flex>
      {onSelect && (
        <Button
          color="brand.red.light"
          paddingInline={0}
          variant="link"
          onClick={(): void => onSelect(store)}
        >
          {t('ACTIONS.SELECT')}
        </Button>
      )}
    </Flex>
  );
};
